import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-job-satisfactions-person-sub-card-cai',
  templateUrl: './job-satisfactions-person-sub-card-cai.component.html',
  styleUrls: ['./job-satisfactions-person-sub-card-cai.component.scss']
})
export class JobSatisfactionsPersonSubCardCaiComponent implements OnInit {

    @Input() record;
    @Input() pos;
    @Input() listView;
    @Input() informationVisibility;

  constructor() { }

  ngOnInit(): void {
  }

}
